import { ObjectToParams } from './urlparser'
const { instance } = require('./url')

async function getCustomerReport(filterJson) {
    const params = ObjectToParams(filterJson)
    return await instance.get('/customerreport' + params)
}

export {
    getCustomerReport,
}
